import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './item.types';

export const itemSelectors = {
  ...generateResourceSelectors<types.IItem>((state) => state.resource.item),
};
